import React, { useEffect, useState } from 'react';
import { Box, Avatar, MenuItem, makeStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowDown from 'src/icons/ArrowDown';
import Trash from 'src/icons/Trash';
import Select from './Select'
import Scrollbar from 'react-scrollbars-custom';

const StyledSelect = withStyles(() => ({
  root: {
    width: 110,
    border: '1px solid #DCDCDC',
    padding: '12px 24px',
    borderRadius: 100,
    height: '25%',
    fontSize: 18,
    fontWeight: 'normal',
    position:'relative',
    zIndex:1,
    '&:focus': {
      borderRadius: 100,
      background: '#fff',
      display: 'flex',
      fontFamily: 'Roboto',
      fontSize: 18,
      fontWeight: 'normal',
      position:'relative',
      zIndex:1,
    },



  },
  nativeInput: {}
}))(Select);
const StyledMenuItem = withStyles(() => ({}))(MenuItem);
const StyledAvatar = withStyles(() => ({
  root: {
    width: '95px',
    height: '95px'
  },
  rounded: {
    borderRadius: 12
  }
}))(Avatar);

const useStyles = makeStyles(() => ({
  mainBox : {
    border: '1px solid #DCDCDC',
    borderRadius: 20,
    padding:'16px 24px',
    marginBottom: 12,
    marginRight:10,
    display: 'flex',
    justifyContent: 'space-between',
    '& div span:first-child': {
      fontWeight: 'bold',
      fontSize: 20,
      fontFamily: 'Roboto'
    },
    '& div span:last-child': {
      fontSize: 18,
      color: '#000',
      fontFamily: 'Roboto',
      fontWeight: 'normal'
    }
  },
  buttonRemove: {
    display:'flex',
    width:48,
    height:48,
    alignItems: 'center',
    justifyContent: 'center',
    border:'1px solid #000',
    borderRadius:'100%',
    cursor: 'pointer',
    transition: '.2s all',
    '&:hover': {
      border:'1px solid #FF5F00',
      // '& $path': {
      //   stroke: '#FF5F00'
      // }
    }
  },
  priceBox: {
      justifyContent: 'flex-start',
      fontWeight: 'bold',
      fontSize: 20,
      fontFamily: 'Roboto',
      marginRight:10,
  },
  rightBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems:'center',
    maxWidth:'400px',
    width:'100%'
  },
  leftBox: {
    display: 'flex',
    justifyContent: 'center'
  },
  spanBox: {
    marginLeft: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width:'100%'
  },
  select:{
    maxWidth:110,
    width:'100%',
    height:48,
    display:'flex',
    '& div svg': {
      position:'relative',
      zIndex:0,
      right:39,
    },
    marginRight:'20px',
    marginLeft:'30px'
  }
}));

const ItemCart = (props) => {
  const classes = useStyles();
  const propsProduct = props?.product ? props.product : null;

  const mediaMatch = window.matchMedia('(max-width: 1440px)');
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = e => setMatches(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  });

  const renderPrice = () => {
      const pointTypeName = propsProduct?.price_point_token_type ? propsProduct.price_point_token_type.name : '';
      return `${props.mode === 'fiat' && props.product.id == 'a7405ba7-bfea-41b8-a184-53281107a815' ? '$' : ''}${price()} ${props.mode === 'points' ? pointTypeName : ''}`;
  }

  const price = () => {
    const quantityMap = props?.productQuantityMap;
    const productQuantity = quantityMap[props.product.id];

    if(props?.mode === 'fiat') {
        return props.product.id == 'a7405ba7-bfea-41b8-a184-53281107a815'? (productQuantity * (props.product.fiat_list_price)/100)  :'' ;
    } 

    if (props?.mode === 'points') {
        return ''
    }

    if (props?.mode === 'cUSD') {
      return `${productQuantity * props.product.list_price_points_tokens / 1} cUSD`
    }
  }

  const styles = {
    container: isMatches => ({

      padding: isMatches ? '24px 32px 24px 24px !important': '16px 24px !important' ,

    })
  };

  return (
    <div className={classes.mainBox} style={matches?{padding:'24px 32px 24px 24px !important'}:{padding:'16px 24px !important'}}>
      <div className={classes.leftBox}>
        <StyledAvatar variant='rounded' src='' />
        <div className={classes.spanBox}>
          <Box component='span'>
            {propsProduct?.product_description}
          </Box>
          <Box component='span'>
            {props?.size}
          </Box>
        </div>
      </div>
      {
        props.mode ==='fiat' &&       <div className={classes.rightBox}>
        <Box component='span' className={classes.priceBox}>
            {renderPrice()}
        </Box>
        <Box className={classes.select}>
              <Select updateProductQuantity={props.updateProductQuantity} product={props.product} mode = {props.mode}/>
          </Box>
          <div className={classes.buttonRemove}>
            <Trash />
          </div>
        </div>
      }

      {
        (props.mode === 'points' || props.mode === 'cUSD') &&       <div className={classes.rightBox}>

        <Box className={classes.select}>
              <Select updateProductQuantity={props.updateProductQuantity} product={props.product} mode = {props.mode}/>
          </Box>
          <Box component='span' className={classes.priceBox}>
            {renderPrice()}
        </Box>
          <div className={classes.buttonRemove}>
            <Trash />
          </div>
        </div>
      }

    </div>
  );
};

export default ItemCart;